<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');

#app {
  text-align: center;
  color: #4F5572;

  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;

  max-width: 375px;
}

.apple-store {
  display: inline-block;
  background: url("./assets/app-store@2x.png") no-repeat;
  background-size: cover;
  width: 210px;
  height: 7rem;
  &.grey {
    background-size: contain;

  }
}
.google-play {
  display: inline-block;
  background: url("./assets/g-play@2x.png") no-repeat;
  background-size: cover;

  width: 210px;
  height: 7rem;

  &.grey {
    background-size: contain;
  }
}

body {
  font-family: Roboto;
  background: #fff;

  margin: 0;
  padding: 0;

  width: 100%;
  height: 100%;

  position: absolute;

  display: flex;
  justify-content: center;
}

h1, h2, h3, h4, h5, h6 {
  font-family: Roboto;
  letter-spacing: 0px;
  text-align: center;
  font-style: normal;
  margin: 0;
}

h1 {
  font-size: 28px;
  font-weight: 700;
  line-height: 33px;
  margin: 1rem 0;
}

h2 {
  font-size: 22px;
  font-weight: 700;
  line-height: 26px;
}

.notice {
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
  color: #BDC5CE;
}

.btn {
  cursor: pointer;

  padding: 15px 10px;
  border-radius: 15px;

  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: center;

  transition: all .1s;

  &:hover {
    transform: scale(0.96);
  }

  &.green {
    background: linear-gradient(180deg, #6ae87c 0%, #6ae87c 100%);
    box-shadow: 0px 4px 0px rgba(0, 0, 0, 0.1);

    color: white;
    font-size: 20px;
  }

  &.yellow {
    background: linear-gradient(180deg, #FFE231 0%, #FFD12C 100%);
    box-shadow: 0px 4px 0px rgba(0, 0, 0, 0.1);
  }

  &.purple {
    background: linear-gradient(180deg, #926AFF 0%, #7948FF 100%);
    box-shadow: 0px 4px 0px rgba(0, 0, 0, 0.1);
    color: #fff;
  }
}

</style>
